// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testConnectionButton {
  background: #F9F9F9 0% 0% no-repeat padding-box;
  border: 1px solid #0079DE;
  border-radius: 4px;
  opacity: 1;
  text-align: center;
  font: normal normal bold 16px/19px Helvetica Neue;
  letter-spacing: 0px;
  color: #0079DE;
  opacity: 1;
  padding: 15px;
}

.connectionStatusText {
  font: normal normal normal 16px/18px Helvetica Neue;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/Screens/Step2/Step2.scss"],"names":[],"mappings":"AAAA;EACA,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA;AACA;;AAEA;EACA,mDAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AACA","sourcesContent":[".testConnectionButton{\nbackground: #F9F9F9 0% 0% no-repeat padding-box;\nborder: 1px solid #0079DE;\nborder-radius: 4px;\nopacity: 1;\ntext-align: center;\nfont: normal normal bold 16px/19px Helvetica Neue;\nletter-spacing: 0px;\ncolor: #0079DE;\nopacity: 1;\npadding: 15px;\n}\n\n.connectionStatusText{\nfont: normal normal normal 16px/18px Helvetica Neue;\nletter-spacing: 0px;\ncolor: #707070;\nopacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
